var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":function($event){return _vm.sendSolvoXml(_vm.personalId, _vm.applicationId)}}},[_c('img',{staticClass:"icon-pdf",attrs:{"src":_vm.iconPath('v_solvo.svg'),"alt":""}}),_vm._v(" Передать в SOLVO.TOS ")])}
var staticRenderFns = []

export { render, staticRenderFns }